module.exports = __webpack_public_path__ + "static/media/CCDF_LOGO-01.6394c0d1.png";